import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";
import { authenticationAppRoutes } from "@circle-react/components/OnboardingPage/helpers/routes";
import { SOCIAL_PROVIDERS } from "../socialProviders";
import { ButtonWithMargin } from "./ButtonWithMargin";

interface LoginOptionsProps {
  formUrl: string;
  variant: "signup" | "signin";
}

export const LoginOptions = ({ formUrl, variant }: LoginOptionsProps) => {
  const {
    currentCommunity,
    currentCommunityPolicies,
    authProviderAuthorizationUrl,
    authProviderName,
    authProviderSignInWithCircleLinkLabel,
  } = useCurrentCommunityContext();

  const localeScope = `authentication_app.${variant}.options`;

  const showLoginButton =
    !currentCommunityPolicies.custom_login_enabled ||
    currentCommunityPolicies.customLoginAllowSignInWithCircle;

  const signInVariant = currentCommunity
    ? currentCommunityPolicies.custom_login_enabled
      ? "secondary"
      : "primary"
    : "marketing-gradient";

  let signInLabel;
  if (!currentCommunityPolicies.customLoginAllowSignInWithCircle) {
    signInLabel = t(`${localeScope}.email`);
  } else if (currentCommunity.white_label) {
    signInLabel = authProviderSignInWithCircleLinkLabel;
  } else {
    signInLabel = t(`${localeScope}.circle`);
  }

  return (
    <>
      {currentCommunityPolicies.custom_login_enabled && (
        <a href={authProviderAuthorizationUrl}>
          <ButtonWithMargin>
            {t(`${localeScope}.auth_provider`, {
              authProviderName: authProviderName,
            })}
          </ButtonWithMargin>
        </a>
      )}

      {showLoginButton && (
        <Link to={`${formUrl}#email`}>
          <ButtonWithMargin variant={signInVariant}>
            {signInLabel}
          </ButtonWithMargin>
        </Link>
      )}
      {currentCommunityPolicies?.showSocialLoginLinks && (
        <>
          {SOCIAL_PROVIDERS.map(({ key, name }) => (
            <a
              key={key}
              href={authenticationAppRoutes.socialSignIn(
                key,
                currentCommunity?.id,
              )}
              data-method="post"
            >
              <ButtonWithMargin variant="secondary">
                {t(`${localeScope}.auth_provider`, {
                  authProviderName: name,
                })}
              </ButtonWithMargin>
            </a>
          ))}
        </>
      )}
    </>
  );
};
